import { TaskDetails } from "./task.model";

export enum TaskExecutionRelevance {

  OPTIONAL = 'OPTIONAL', //
  DEFAULT = 'DEFAULT', //
  CRITICAL = 'CRITICAL'

}

export class TaskExecution {

  source: string;
  sourceId: string;
  task: TaskDetails;
  relevance: TaskExecutionRelevance;

  constructor(execution?: Partial<TaskExecution>) {
    if (execution != null) {
      this.source = execution.source;
      this.sourceId = execution.sourceId;
      if (execution.task != null) {
        this.task = new TaskDetails(execution.task);
      }
      this.relevance = execution.relevance;
    }
  }

}
